import styled from "styled-components";

const secondaryColor = 'white';


export const Header = styled.div`
  max-width: 100%;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const GlassBoxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`
export const BackgroundPyramid = styled.div`
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid hsl(221, 48.7%, 7.6%);
  transform: rotate(180deg);
  border-width: 49vw;
  position: absolute;
  top: 0;
  z-index: -1;
`

export const GlassBox = styled.div`
  width: 350px;
  transform: translateY(-20px);
  border-radius: 0.5rem;
  position: relative;
  padding: 1rem;
  padding-top: 3.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Icons = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 2rem;
  top: 50%;
  transform: translateY(-50%);
  space-between: 2px;
  z-index: 1000;
`

export const IconLink = styled.a`
  margin-top: .75rem;
  margin-bottom: .75rem;
  margin-left: 3.75rem;
  i {
      text-align: center;
      font-size: 35px;
      transition: color 1s, opacity 1s;
      opacity:0.4;
      color: white;
  }
  i:hover {
      opacity: 1;
      color: ${props => props.color};
  }
`

export const AvatarBorder = styled.div`
  border: 3.5px solid white;
  justify-self: center;
  width: 165px;
  height: 165px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-bottom: .10rem;
`

export const AvatarImage = styled.img`
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
`

export const Name = styled.a`
  font-size: 26px;
  font-weight: 600;
  color: white;
  margin-bottom: 0.2rem;
  a:hover {
    cursor: pointer;
  }
`

export const Tag = styled.div`
  color: ${secondaryColor};
  opacity: 0.6;
  font-weight: 500;
  margin-bottom: 1rem;
  font-size: 14px;
`

export const Stats = styled.div`
  display: flex;
  text-align: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  height: 100px;

  a {
  color: white;
  scale: 1;
  opacity: 0.8;
  transition: scale 0.3s, opacity 0.3s;
  }

  a:hover{
  scale: 1.02;
  opacity: 1;
  padding-bottom: 0.5rem;
`;

export const Stat = styled.a`
  h2 {
    font-size: 30px;
    color: ${secondaryColor};
  }
  p {
    margin-top: 0.1rem;
    font-size: 13px;
    color: ${secondaryColor};
    opacity: 0.6;
    font-weight: 500;
    line-height: 14px;
  }
`;

export const Buttons = styled.div`
  width: 100%;
  margin-bottom: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

`;

export const Button = styled.a`
  width: 100%;
  background-color: ${props => props.cta ? 'white' : 'transparent'};
  border: ${props => props.cta ? 'none' : '1px solid white'};
  color: ${props => props.cta ? '#091b3f' : 'white'};
  width: ${props => props.cta ? '50%' : 'auto'};

  width: ${props => props.sa ? '50%' : 'auto'};

  cursor: pointer;
  padding: 12px;
  text-align: center;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    margin-right: ${props => props.cta ? '0.5rem' : '0'};
    margin-left: ${props => props.sa ? '0.5rem' : '0'};
  }
`;

export const SlideDot = styled.div`
  border-radius: 50%;
`;

export const MainDivide = styled.div`
  width: 100%;
  margin: 2rem 0 2.5rem;
  background-color: transparent;
  padding: .375rem;
  border-radius: .75rem;
  display: flex;
  justify-content: center;
  column-gap: .5rem;
`

export const ButtonContainer = styled.div`
  background-color: hsl(208, 24.6%, 12%);
  border-radius: .75rem;
  display: flex;
  justify-content: center;
  border: none;
  outline: none;
`

export const NavButton = styled.div`
  width: 8rem;
  border: none;
  outline: none;
  padding: 1rem;
  padding-left: 1.7rem;
  padding-right: 1.7rem;
  color: white;
  font-weight: 500;
  border-radius: .75rem;
  display: flex;
  justify-content: center;
  cursor: pointer;
  background-color: hsl(208, 24.6%, 12%);
  transition: .3s;
`
export const Footer = styled.div`
margin-top: 2rem;
bottom: 0;
font-size: 13px;
color: ${secondaryColor};
opacity: 0.8;
font-weight: 500;
line-height: 14px;
`


/*
Snack Track
Avon
Study Buddy
University
Socket Chat
joinly
DalCS
*/
